import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Phone, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function WhyRenovateSection({ onBookingClick }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      ref={ref}
      className="py-24 md:py-32 bg-accent/10"
      data-testid="why-renovate-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="space-y-8"
        >
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight leading-tight"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            Vasker du bilen inden den skal sælges
            <br />
            <span className="text-primary">— hvorfor ikke gøre det samme med huset?</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
            <p>
              Vi tager os af alle de små ting og processen tager typisk <strong className="text-foreground">2-3 uger</strong> før huset er klar til salg.
            </p>
            <p>
              Vi samarbejder med din <strong className="text-foreground">ejendomsmægler eller advokat</strong> i hele processen.
            </p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex justify-center pt-4"
          >
            <Button
              asChild
              size="lg"
              className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none px-8 py-6 text-base"
            >
              <a href="tel:+4561362199" data-testid="call-jakob-btn">
                <Phone className="mr-2 w-5 h-5" />
                Ring til Jakob
              </a>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
